module.exports = {"pathContext":{"name":"CensusAppointmentAssignmentFilter","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"assignedOnly","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"assignmentStatus","type":{"kind":"ENUM","name":"CensusAssignmentStatus","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-census-appointment-assignment-filter.json
// module id = 1375
// module chunks = 111826146443291